import React from 'react';
import Bubble from '@splunk/dashboard-visualizations/Bubble';

export default () => (
    <Bubble
        options={{}}
        encoding={{
            category: 'primary.category',
            size: 'primary.date_wday',
            x: 'primary.date_hour',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [
                        {
                            name: 'date_hour',
                        },
                        {
                            name: 'date_wday',
                        },
                        {
                            name: 'count',
                        },
                        {
                            name: 'category',
                        },
                    ],
                    columns: [
                        [
                            '12',
                            '11',
                            '9',
                            '16',
                            '8',
                            '20',
                            '19',
                            '17',
                            '22',
                            '15',
                            '23',
                            '12',
                            '20',
                            '1',
                            '10',
                        ],
                        [
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                            'tuesday',
                            'wednesday',
                            'thursday',
                            'friday',
                            'saturday',
                            'sunday',
                            'monday',
                        ],
                        [3, 2, 4, 1, 8, 11, 16, 1, 3, 2, 2, 2, 11, 11, 5],
                        [
                            'Gen Electric GE36',
                            'General Electric TF39 high bypass turbofan',
                            'Pratt & Whitney R-4360 Wasp Major',
                            'Allison V-1710',
                            'Sanford Alexander Moss',
                            'Armstrong Siddeley Jaguar IV (S)',
                            'BMW VI',
                            'Auguste Rateau',
                            'Bristol Mercury',
                            'P&Whitney R-4360',
                            'Sanford Alexander Moss',
                            'Jendrassik Cs-1',
                            'Gen Electric GE36',
                            'Bell X-1',
                            'P&Whitney R-4360',
                        ],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
